/** iOS Safari (нет beforeinstallprompt) */
export function isIos() {
  if (typeof navigator === "undefined") return false;
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

export function isStandaloneMode() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true ||
    document.referrer.includes("android-app://")
  );
}

export function canShowInstallBanner(dismissKey) {
  if (typeof localStorage === "undefined") return false;
  if (localStorage.getItem(dismissKey) === "1") return false;
  if (isStandaloneMode()) return false;
  return true;
}
